import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import './assets/css/iconfont.css';
import './permission';
import ElementUI from 'element-plus';
import 'element-plus/theme-chalk/index.css'






const app = createApp(App);
app.use(router);
app.use(store);
app.use(ElementUI);

app.mount('#app')
